import { render, staticRenderFns } from "./JoinSubject.vue?vue&type=template&id=cbab1d84&scoped=true&"
import script from "./JoinSubject.vue?vue&type=script&lang=js&"
export * from "./JoinSubject.vue?vue&type=script&lang=js&"
import style0 from "./JoinSubject.vue?vue&type=style&index=0&id=cbab1d84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbab1d84",
  null
  
)

export default component.exports